import { twMerge } from "tailwind-merge";
import { useCatalog } from "./Catalog.context";

export default function CatalogContainer({ children }) {
  const { isResponsive } = useCatalog();

  return (
    <div
      className={twMerge(
        "relative flex h-screen w-full items-center justify-center overflow-hidden bg-black",
        !isResponsive && "overflow-hidden",
        isResponsive && "block h-auto min-h-screen bg-white",
      )}
    >
      {children}
    </div>
  );
}
